import React, { useState } from 'react';
import { FiDownload, FiInfo, FiEdit2 } from 'react-icons/fi';
import * as jobsActions from '../../Redux/Actions/jobs';
import { downloadFile, dateTimeFormat } from '../../utils';
import ImageModal from './imageModal';
import '../../assets/table.css'; 
import { useSelector } from 'react-redux';

const ReferenceList = ({ t, data, jobID, setReferenceModal, setReferenceEditData, editFlag }) => {

    const [imageModal, setImageModal] = useState(false);
    const [imgData, setImgData] = useState('');
    const [imgName, setImgName] = useState('');

    const { unEditableFlag } = useSelector(state => state.jobInfo);

    const handleGetPaymentReceipt = (documentID) => {
        jobsActions.getMetaDataPaymentReceipt(documentID).then(res => {
            let documentData = res.data[0];
            if (documentData) {
                setImageModal(true);
                setImgData(documentData.thumbnailUri);
                setImgName(documentData.fileName);
            }
        }).catch(err => {
            console.log('Unable to get payment receipts meta data', err);
        });
    };

    const handleDownloadPaymentReceipt = (documentID) => {
        jobsActions.downloadPaymentReceipt(documentID).then(res => {
            res && downloadFile(res);
        }).catch((err) => {
            console.log('Something Went Wrong', err);
        });
    };

    return (
        <div className="card card-custom card-stretch gutter-b">
            <div className="card-body pb-3">
                <h3 className="card-title font-weight-bolder text-dark">{t("jobsManagement.infoJob.references.title")}</h3>
                <div className="d-flex mt-2">
                    {(data.length === 0) ? <p className="text-muted text-center">{t("jobsManagement.noDataAvailable")}</p> : <div className="table-responsive">
                        <table className="table tableFreez table-head-custom table-vertical-center table-head-bg">
                            <thead>
                                <tr className="text-left">
                                    <th className="pl-7" style={{width: '50px'}}>{t("jobsManagement.infoJob.references.sNo")}</th>
                                    <th style={{width: '80px'}}>{t("jobsManagement.infoJob.references.jobID")}</th>
                                    <th style={{width: '180px'}}>{t("jobsManagement.infoJob.references.receiptName")}</th>
                                    <th style={{width: '100px'}}>{t("jobsManagement.infoJob.references.receiptNo")}</th>
                                    <th style={{width: '80px'}}>{t("jobsManagement.infoJob.references.amount")}</th>
                                    <th style={{width: '120px'}}>{t("jobsManagement.infoJob.references.status")}</th>
                                    <th style={{width: '160px'}}>{t("jobsManagement.infoJob.references.approval")}</th>
                                    <th style={{width: '160px'}}>{t("jobsManagement.infoJob.references.receiptProcessed")}</th>
                                    <th style={{width: '160px'}}>{t("jobsManagement.infoJob.references.approvedBy")}</th>
                                    <th style={{width: '160px'}}>{t("jobsManagement.infoJob.references.approvedTime")}</th>
                                    <th style={{width: '120px'}}>{t("jobsManagement.infoJob.references.action")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((reference, index) => {
                                    let status = (reference.approvedStatus && reference.approvedStatus.toLowerCase());
                                    let receiptStatus = (reference.isProcessed);
                                    return (
                                    <tr key={index}>
                                        <td className="pl-7">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{index+1}</span>
                                        </td>
                                        <td>
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{jobID}</span>
                                        </td>
                                        <td>
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{(reference.key && reference.key.length > 20) ? reference.key.slice(0,19) + '..' : reference.key}</span>
                                        </td>
                                        <td className="pl-0 py-8">
                                            <span className="text-dark-75 font-weight-bolder text-hover-primary d-block font-size-lg">{reference.receiptNumber}</span>
                                        </td>
                                        <td>
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{reference.payableAmount}</span>
                                        </td>
                                        <td style={{whiteSpace: 'nowrap'}}>
                                            <span className={"p-2 badge badge-outline-purple"} style={{borderRadius: '3px', width: 'auto'}}>
                                                {(reference.paymentDetails && reference.paymentDetails.status && reference.paymentDetails.status.toLowerCase() === 'open') ? t("jobsManagement.infoJob.references.open") : t("jobsManagement.infoJob.references.closed")}
                                            </span>
                                        </td>
                                        <td style={{whiteSpace: 'nowrap'}}> 
                                                {
                                                    <span className={"p-2 badge badge-outline-" + (status === 'pending' ? "warning" : status === 'approved'? "success" : "danger")} style={{borderRadius: '3px', width: 'auto'}} >
                                                        {status === 'pending' ? t("jobsManagement.infoJob.references.pending") : status === 'approved'? t("jobsManagement.infoJob.references.approved") : t("jobsManagement.infoJob.references.rejected")}
                                                    </span>
                                                } 
                                        </td>
                                        <td style={{whiteSpace: 'nowrap'}}> 
                                                {
                                                    <span className={"p-2 badge badge-outline-" + (receiptStatus ? 'success' : 'danger')} style={{borderRadius: '3px', width: 'auto'}} >
                                                        {receiptStatus ? t("jobsManagement.infoJob.references.processed") : t("jobsManagement.infoJob.references.notProcessed")}
                                                    </span>
                                                } 
                                        </td>
                                        <td>
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg" style={{textAlign: 'center'}}>{reference.approvedBy !== null ? reference.approvedBy : '-'}</span>
                                        </td>
                                        <td>
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg" style={{textAlign: 'center'}}>{reference.approvedTime !== null ? dateTimeFormat(reference.approvedTime) : '-' }</span>
                                        </td>
                                        <td>
                                            {(status === 'rejected' && !unEditableFlag) ? <FiEdit2 className="c-pointer font-16 me-lg-2" onClick={() => {setReferenceModal(true); setReferenceEditData(reference)}} /> : null }
                                            {((reference.value === null) || (reference.value === '')) ? <>No Document</> : <>
                                                <FiInfo className="c-pointer font-16 me-lg-2" onClick={() => handleGetPaymentReceipt(reference.value)} />
                                                {editFlag && <FiDownload className="c-pointer font-16" onClick={() => handleDownloadPaymentReceipt(reference.value)} />}
                                            </>}
                                        </td>
                                    </tr>
                                )})}
                            </tbody>
                        </table>
                    </div>}
                </div>
                {imageModal && <ImageModal name={imgName} data={imgData} showModal={imageModal} handleCancel={() => setImageModal(false)} />}
            </div>
        </div>
    );
};

export default ReferenceList;